import {Http} from "oca-lib-web";

export default class CustomDataAccess {

    public data:Array<{id:string, name:string, results:Array<any>}> = [];

    public fetchData(dataSource:DataSource, timeInterval:TimeInterval):any {
        var self = this;
        return new Promise(async function(resolve) {
            console.log("About to fetch custom data for timeframe " + timeInterval.start + " - " + timeInterval.end);
            let queryParams = "/?startDate=" + timeInterval.start + "&endDate=" + timeInterval.end;
            let params = JSON.parse(dataSource.params);
            console.log(params.dataSourceUri + queryParams)
            let results;
            try {
                results = await Http.get(params.dataSourceUri + queryParams);
                console.log(results);
                self.data.push({id: dataSource.id, name: dataSource.dataSourceName + " - " + params.dataSourceName, results: results});
            } catch (e) {
                console.error(e);
            }

            resolve(true);
        });
    }

    public getResults(id:String):Array<any> {
        for (let dataItem of this.data) {
            if (dataItem.id == id) {
                return dataItem.results;
            }
        }
        //console.log("Could not get custom data for " + id)
        return [];
    }

    public clearData() {
        this.data = [];
    }
}